module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team-member team-member__section-plugin"
  }, [_c('div', {
    staticClass: "team-member--root"
  }, [_c('div', {
    ref: "teamMember",
    staticClass: "team-member--identity",
    class: {
      visible: _vm.isVisible
    }
  }, [_c('img', _vm._b({
    staticClass: "team-member--image",
    class: {
      'team-member--image-primary': _vm.hoverImageData.src !== _vm.imageData.src
    }
  }, 'img', _vm.imageData, false)), _vm._v(" "), (_vm.hoverImageData.src !== _vm.imageData.src) ? _c('img', _vm._b({
    staticClass: "team-member--image team-member--image-secondary"
  }, 'img', _vm.hoverImageData, false)) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "team-member--description"
  }, [_c('h3', {
    staticClass: "team-member--name",
    domProps: {
      "textContent": _vm._s(_vm.content.name)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "team-member--job-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.job)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team-member--contact"
  }, [_c('a', {
    staticClass: "team-member--contact-email u-reset",
    attrs: {
      "href": _vm.content.email_link
    }
  }, [_c('cmp-icon', {
    attrs: {
      "symbol": "mail",
      "size": "small"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "team-member--contact-phone u-reset",
    attrs: {
      "href": _vm.content.phone_link
    }
  }, [_c('cmp-icon', {
    attrs: {
      "symbol": "phone",
      "size": "small"
    }
  })], 1), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.phone_label)
    }
  })])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-219f8a58", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-219f8a58","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/team-member/index.vue
// module id = 514
// module chunks = 7